export default __webpack_public_path__ + "static/media/singleLegSquatAvatar.118bb037.png";